import React from "react";
import ReactDOM from "react-dom";
import "./semantic/dist/semantic.min.css";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import store from './store/store';
import LogRocket from 'logrocket';

LogRocket.init(process.env.REACT_APP_LOGROCKET_INIT_KEY);
ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js